import React from 'react';

import classes from './flare.module.scss';

const Flare: React.FC = () => (
  <div className={classes.ct}>
    <div className={classes.flare} />
  </div>
);
export default Flare;